<template>
  <div :class="[textAlignClass]" class="ps-spinner ps-w-full">
    <div :class="[sizeClass, bgClass]" class="ps-bounce-1 ps-mr-px"></div>
    <div :class="[sizeClass, bgClass]" class="ps-bounce-2 ps-mr-px"></div>
    <div :class="[sizeClass, bgClass]" class="ps-bounce-3 ps-mr-px"></div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    size: {
      type: Number,
      default: 5
    },
    bgColor: {
      type: String,
      default: 'brand-brown-100'
    },
    textAlign: {
      type: String,
      default: 'center'
    }
  },
  computed: {
    sizeClass() {
      return `ps-w-${this.size} ps-h-${this.size}`
    },
    bgClass() {
      return `ps-bg-${this.bgColor}`
    },
    textAlignClass() {
      return `ps-text-${this.textAlign}`
    }
  }
}
</script>

<style lang="postcss" scoped>
.ps-spinner > div {
  /* width: 18px;
  height: 18px;
  background-color: #333; */

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.ps-spinner .ps-bounce-1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.ps-spinner .ps-bounce-2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>